import React from 'react';

import { Typography } from '@mui/material';

import {
  bureausStyles,
  cellStyles,
  descriptionCellStyles,
  descriptionStyles,
} from './CreditReporting.styles';

export const getCreditReportingTableConfig = () => ({
  bureaus: {
    label: 'Bureaus',
    rowSpan: ({ bureaus }) => bureaus?.rowSpan,
    colSpan: ({ bureaus }) => bureaus?.colSpan,
    customStyles: ({ bureaus }) => (bureaus?.isDescription ? descriptionCellStyles : null),
    content: ({ bureaus }) => (
      <Typography
        sx={bureaus?.isDescription ? descriptionStyles : bureausStyles}
        variant="regular14"
      >
        {bureaus?.value}
      </Typography>
    ),
    isPermanent: false,
  },
  equifax: {
    label: 'Equifax',
    content: ({ equifax }) => equifax,
    customStyles: () => cellStyles,
    isPermanent: false,
  },
  experian: {
    label: 'Experian',
    content: ({ experian }) => experian,
    customStyles: () => cellStyles,
    isPermanent: false,
  },
  transUnion: {
    label: 'TransUnion',
    content: ({ transUnion }) => transUnion,
    customStyles: () => cellStyles,
    isPermanent: false,
  },
});
